import {
  DetailPanel,
  DetailPanelGrid,
  type DetailPanelGridProps,
  type DetailPanelProps,
} from '@/components/shared';

export type InterviewDetailPanelGridProps = DetailPanelGridProps;
export type InterviewDetailPanelProps = DetailPanelProps;

export const InterviewDetailPanelGrid = DetailPanelGrid;
export const InterviewDetailPanel = DetailPanel;
